var React = require('react');

function PaginationRightArrow (props) {
    return React.createElement("svg",props,React.createElement("polygon",{"points":"7.293 4.707 14.586 12 7.293 19.293 8.707 20.707 17.414 12 8.707 3.293 7.293 4.707"}));
}

PaginationRightArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = PaginationRightArrow;

PaginationRightArrow.default = PaginationRightArrow;
